import React from "react";
import './TopFeature.scss';

type TopFeatureProps = {
  image?: any;
  imageAltText?: string;
  title?: string;
  body?: string;
};

type TopFeaturesProps = {
  features?: TopFeatureProps[];
};

export const TopFeature = ({ features }: TopFeaturesProps) => {
  return (
    <div className="c-hex-result-page-top-features">
      {features?.map((feat) => (
        <div className="c-hex-top-feature" key={feat?.title}>
          <div className="c-hex-top-feature-image">
            <img src={feat.image} alt={feat?.imageAltText} />
          </div>
          <p className="c-hex-top-feature-title">{feat?.title}</p>
          <p className="c-hex-top-feature-body">{feat?.body}</p>
        </div>
      ))}
    </div>
  );
};
